// src/components/SmartFlow/nodes/TriggerNode.jsx

import React from 'react';
import BaseNode from './base/BaseNode';

/**
 * Trigger Node Component
 * Starting point of a workflow
 */
const TriggerNode = ({ data, selected }) => {
  const config = data.config || {};
  const triggerType = config.trigger_type || data.label || 'Manual';

  return (
    <BaseNode
      data={data}
      icon="bi-lightning-charge"
      color="#7B68EE"
      label="Trigger"
      subtitle={triggerType}
      hasHandles={{ top: false, bottom: true }}
      selected={selected}
    />
  );
};

export default TriggerNode;
